/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationBaseForAIPromptAnalytics extends models.GovernanceConfigurationBaseForOperations {
    getFixupPrototypeFunction() { return GovernanceConfigurationBaseForAIPromptAnalytics.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationBaseForAIPromptAnalytics>): GovernanceConfigurationBaseForAIPromptAnalytics {
        let obj = Object.assign(new GovernanceConfigurationBaseForAIPromptAnalytics(), model);
        GovernanceConfigurationBaseForAIPromptAnalytics.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationBaseForAIPromptAnalytics>): GovernanceConfigurationBaseForAIPromptAnalytics {
        if (!model) return null;
        return GovernanceConfigurationBaseForAIPromptAnalytics.newInstance(<GovernanceConfigurationBaseForAIPromptAnalytics> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationBaseForAIPromptAnalytics) {
        if (!obj) return;

        models.GovernanceConfigurationBaseForAIPromptAnalytics.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationBaseForAIPromptAnalytics): boolean {
        if (models.GovernanceConfigurationBaseForOperations.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationBaseForAIPromptAnalytics.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
